jQuery(function($) {
    'use strict';

    /**
     * Follow us module and subscription
     */

    function newsletter_subscribe(form) {
        
        var form_data = {
            email: form.find('[name="email"]').val(),
            slug: form.find('[name="slug"]').val()
        };
        
        if (newsletter_validate(form)) {
            
            $.ajax({
                url: 'https://' + window.location.host + '/api/fe/newsletter-signup/',
                type: 'POST',
                data: form_data,
                dataType: 'json',
                success: function (response) {
                    if (response.status === 'Success') {
                        form.html(form.find('.signup_success').html());
                    } else if (response.status === 'Error') {
                        if(form.hasClass('landing-page')) {
                            form.find('.signup_failure').show();
                        } else {
                            form.html(form.find('.signup_failure').html());
                        }
                    }
                    if(form.hasClass('toaster')) {
                        setTimeout(function() {
                            form.closest('newsletter-toaster').addClass('hidden');
                        }, 5000);
                    }
                },
                error: function () {
                    if(form.hasClass('landing-page')) {
                        form.find('.signup_failure').show();
                    } else {
                        form.html(form.find('.signup_failure').html());
                    }
                    
                }
            });
        }
    }
    function newsletter_validateEmail(email) {
        return /^(.*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(email);
    }

    function newsletter_validate(form) {
        
        var email = form.find('[name="email"]').val();
        var accept_terms = form.find('input[name="accept-terms"]');
        var validated_email = true;
        var validated_terms = true;

        if (newsletter_validateEmail(email)) {
            form.find('.signup_error').css('display','none');
            validated_email = true;
        } else {
            form.find('.signup_error').css('display','block');
            validated_email = false;
        } 
        
        if ( accept_terms.length ) {
            
            if ( accept_terms.is(':checked') ) {
                validated_terms = true;
                form.find('.signup_error_terms').css('display','none');
            } else {
                validated_terms = false;
                form.find('.signup_error_terms').css('display','block');
            }
        }
        if (validated_email && validated_terms) {
            return true;
        } 
        return false;
    }
    
    var modSubscribe = {
        el: '.email form.newsletter-signup',

        init: function() {

            this.$el = $(this.el);
            var _this = this;
            this.$el.submit(function(e){
                e.preventDefault();
                newsletter_subscribe(_this.$el);
            });
        }
    };

    modSubscribe.init();
    
    var modNewsletterToaster = {
        el: '.newsletter-toaster form.newsletter-signup',
        close: '.newsletter-toaster__close-button',
        toaster: '.newsletter-toaster',
        init: function() {
            
            this.$el = $(this.el);
            this.$toaster = $(this.toaster);            
            
            var _this = this;

            $(this.close).on('click', function(e){
                e.preventDefault();
                e.stopPropagation();

                _this.$toaster.addClass('hidden');
            });
            if(this.$el.length && !Cookies.get('newsletter_toaster_' + this.$el.find('[name="newsid"]').val())) {
                this.$toaster.removeClass('hidden');

                var minExpiry = 25; // days
                var maxExpiry = 30; // days
                var expiresIn = Math.floor(Math.random() * (maxExpiry + 1 - minExpiry)) + minExpiry;
                Cookies.set('newsletter_toaster_' + this.$el.find('[name="newsid"]').val(), 1, { expires: expiresIn });
            }
            this.$el.submit(function(e) {
                e.preventDefault();
                newsletter_subscribe(_this.$el);
            });
        }
    };

    modNewsletterToaster.init();

    $('.follow-us-networks-item').socialOverlayToggle();
});
